import { render, staticRenderFns } from "./FacebookLogin.vue?vue&type=template&id=5c27ef5d"
import script from "./FacebookLogin.vue?vue&type=script&lang=js"
export * from "./FacebookLogin.vue?vue&type=script&lang=js"
import style0 from "./FacebookLogin.vue?vue&type=style&index=0&id=5c27ef5d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports